import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Hidden from "@material-ui/core/Hidden";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons components
import DirectionsRun from "@material-ui/icons/DirectionsRun";
import Lock from "@material-ui/icons/Lock";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";

// core components
import componentStyles from "assets/theme/components/dropdowns/user-dropdown.js";
import storageFnc from "lib/localStorage.js";
import UtilsFncs from "utils/UtilsFncs";
import DialogChangePassword from "components/Dialogs/DialogChangePassword";
import DialogNotifications from "components/Dialogs/DialogNotifications";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { removeUserFirebaseId } from "components/Notification/Notifications";
import { Person } from "@mui/icons-material";
import { getUserName } from "utils/get-user-info";

const useStyles = makeStyles(componentStyles);

const Option = ({ onClick, component, text }) => (
  <Box
    display="flex!important"
    alignItems="center!important"
    component={MenuItem}
    onClick={onClick}
  >
    <Box
      component={component}
      width="1.25rem!important"
      height="1.25rem!important"
      marginRight="1rem"
    />
    <span>{text}</span>
  </Box>
);

export default function UserDropdown() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openChangePassword, setOpenChangePassword] = React.useState();
  const [openNotificationsDialog, setOpenNotificationsDialog] =
    React.useState();
  const isMenuOpen = Boolean(anchorEl);
  const userName = getUserName();
  const snackbar = useSnackbar();

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const updateUserNotificationId = React.useCallback(
    async (idFirebase) => {
      return removeUserFirebaseId(idFirebase).catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
      });
    },
    [snackbar]
  );

  const handleLogOut = (event) => {
    event.preventDefault();
    handleMenuClose();

    const userFirebaseId = localStorage.getItem("userFirebaseId");

    if (userFirebaseId) {
      updateUserNotificationId(userFirebaseId);
      localStorage.removeItem("userFirebaseId");
    }

    storageFnc.clear();

    if (window.location.href.includes("karsten-portal-b2b-test")) {
      window.location.href = process.env.PUBLIC_URL + "/index.html?auth";
    } else {
      UtilsFncs.RedirectToLoginPage();
    }
  };

  const toggleChangePassword = React.useCallback(() => {
    setOpenChangePassword(!openChangePassword);
  }, [openChangePassword]);

  const toggleNotificationsDialog = React.useCallback(() => {
    setOpenNotificationsDialog(!openNotificationsDialog);
  }, [openNotificationsDialog]);

  const options = [
    {
      onClick: toggleChangePassword,
      component: Lock,
      text: "Alterar senha",
    },
    {
      onClick: toggleNotificationsDialog,
      component: NotificationsActiveIcon,
      text: "Notificações",
    },
    {
      onClick: handleLogOut,
      component: DirectionsRun,
      text: "Logout",
    },
  ];

  const menuId = "dropdowns-user-dropdown-id";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <Typography
        variant="h6"
        component="h6"
        classes={{ root: classes.menuTitle }}
      >
        Bem-vindo!
      </Typography>
      {/* <Box
        display="flex!important"
        alignItems="center!important"
        component={MenuItem}
        onClick={handleMenuClose}
      >
        <Box
          component={Person}
          width="1.25rem!important"
          height="1.25rem!important"
          marginRight="1rem"
        />
        <span>My profile</span>
      </Box> */}
      {/* <Box
        display="flex!important"
        alignItems="center!important"
        component={MenuItem}
        onClick={handleMenuClose}
      >
        <Box
          component={Settings}
          width="1.25rem!important"
          height="1.25rem!important"
          marginRight="1rem"
        />
        <span>Settings</span>
      </Box>
      <Box
        display="flex!important"
        alignItems="center!important"
        component={MenuItem}
        onClick={handleMenuClose}
      >
        <Box
          component={EventNote}
          width="1.25rem!important"
          height="1.25rem!important"
          marginRight="1rem"
        />
        <span>Activity</span>
      </Box>
      <Box
        display="flex!important"
        alignItems="center!important"
        component={MenuItem}
        onClick={handleMenuClose}
      >
        <Box
          component={LiveHelp}
          width="1.25rem!important"
          height="1.25rem!important"
          marginRight="1rem"
        />
        <span>Support</span>
      </Box> */}
      <Divider component="div" classes={{ root: classes.dividerRoot }} />
      {options?.map((option, index) => (
        <Option key={index} {...option} />
      ))}
    </Menu>
  );

  return (
    <div
      role="presentation"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Button
        edge="end"
        aria-label="account of current user"
        aria-controls={menuId}
        aria-haspopup="true"
        onClick={handleProfileMenuOpen}
        color="inherit"
        classes={{
          label: classes.buttonLabel,
          root: classes.buttonRoot,
        }}
      >
        <Person fontSize="large" style={{ marginRight: "0.5rem" }} />
        <Hidden mdDown>
          {userName ? userName : "Usuário não encontrado"}
        </Hidden>
      </Button>
      {localStorage.getItem("userVision") &&
        localStorage.getItem("userVision") !== "default" && (
          <Button
            edge="end"
            aria-label="account of current user"
            aria-controls={menuId}
            aria-haspopup="true"
            disabled
            color="inherit"
            style={{ backgroundColor: "#4585d9" }}
            classes={{
              label: classes.buttonLabelVision,
            }}
          >
            <Hidden>
              Usuário selecionado: {localStorage.getItem("userVision")}
            </Hidden>
          </Button>
        )}
      {renderMenu}
      {openChangePassword && (
        <DialogChangePassword
          open={openChangePassword}
          handleClose={toggleChangePassword}
        />
      )}
      {openNotificationsDialog && (
        <DialogNotifications
          open={openNotificationsDialog}
          handleClose={toggleNotificationsDialog}
        />
      )}
    </div>
  );
}
